import { BusinessUnitDto } from "@sharedcommon/model/organization/business-unit.model";
import { SampleDashboardDto } from "./sample/sample-dashboard.model";
import { LevelDto, PredictionModelDto, ReferenceDto } from "@sharedcommon/rest/data.restservice";
import { SupplierDto } from "@sharedcommon/model/organization/supplier.model";
import { EntityDto } from "@sharedcommon/rest/identity.restservice";
import { SpeciesDto } from "./sample/species.model";

export class SampleAdvancedSearchCriterias {
  businessUnits: BusinessUnitDto[];
  entities: EntityDto[];
  suppliers: SupplierDto[];
  /** All selected levels (without any filter) */
  levels: LevelDto[];
  /** The selected levels which are the leaves of the level tree (levels with no children or null children) */
  filteredLevels: LevelDto[];
  predictionModels: PredictionModelDto[];
  references: ReferenceDto[];
  technicianNames: string[];
  samples: SampleDashboardDto[];
  farmNames: string[];
  startValidationDate: Date;
  endValidationDate: Date;
  distributorNames: string[];
  startReceptionDate: Date;
  endReceptionDate: Date;
  allSpecies: SpeciesDto[];
}
